//文字コードはutf-8

/**
 * パララックス効果の初期化
 */
export function initTopParallax() {
  const parallaxContainer = document.querySelector('.jsParallax');
  
  if (!parallaxContainer) {
    return;
  }
  
  const sections = parallaxContainer.querySelectorAll('.jsParallax__section');
  const imageContainer = parallaxContainer.querySelector('.jsParallax__img');
  // HTML構造が変わったため、.jsParallax__img__innerで取得（以前は.jsParallax__img img）
  const images = parallaxContainer.querySelectorAll('.jsParallax__img__inner');
  
  if (sections.length === 0 || images.length === 0 || !imageContainer) {
    return;
  }
  
  let currentActiveIndex = 0;
  let isUpdating = false;
  
  /**
   * アクティブな画像を更新
   * @param {number} newIndex - 新しくアクティブにするインデックス
   */
  function updateActiveImage(newIndex) {
    if (newIndex === currentActiveIndex || isUpdating) {
      return;
    }
    
    isUpdating = true;
    
    // 全ての画像からis-activeを削除
    images.forEach(img => {
      img.classList.remove('is-active');
    });
    
    // data-index属性を使用して該当する画像を探す（DOM順序に依存しない方法）
    const targetImage = Array.from(images).find(img => {
      const index = parseInt(img.getAttribute('data-index'), 10);
      return index === newIndex;
    });
    
    // 見つからなかった場合は配列のインデックスでフォールバック
    const imageToActivate = targetImage || images[newIndex];
    
    if (imageToActivate) {
      imageToActivate.classList.add('is-active');
      currentActiveIndex = newIndex;
    }
    
    // トランジション完了後にフラグをリセット
    setTimeout(() => {
      isUpdating = false;
    }, 100);
  }
  
  /**
   * スクロール位置に基づいて画像コンテナの表示/非表示とアクティブな画像を制御
   */
  function handleScroll() {
    const containerRect = parallaxContainer.getBoundingClientRect();
    const containerTop = containerRect.top;
    const containerBottom = containerRect.bottom;
    const viewportHeight = window.innerHeight;
    
    // アニメーション開始前：position: relativeでセクション内に収める、最初の画像を表示
    if (containerTop > 0) {
      imageContainer.classList.remove('is-fixed', 'is-bottom');
      imageContainer.classList.add('is-visible');
      updateActiveImage(0);
      return;
    }
    
    // アニメーション終了後：position: absolute (bottom: 0)、最後の画像を表示
    if (containerBottom < viewportHeight) {
      imageContainer.classList.remove('is-fixed');
      imageContainer.classList.add('is-bottom', 'is-visible');
      updateActiveImage(sections.length - 1);
      return;
    }
    
    // アニメーション中：position: fixed (top: 0)、通常のパララックス処理
    imageContainer.classList.remove('is-bottom');
    imageContainer.classList.add('is-fixed', 'is-visible');
    
    // ビューポートの中央位置
    const viewportCenter = window.scrollY + viewportHeight / 2;
    
    // 各セクションをチェックして、中央に最も近いセクションを見つける
    let closestIndex = 0;
    let closestDistance = Infinity;
    
    sections.forEach((section, index) => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionCenter = sectionTop + rect.height / 2;
      const distance = Math.abs(viewportCenter - sectionCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
    
    updateActiveImage(closestIndex);
  }
  
  // スクロールイベントのスロットリング用
  let scrollTimer = null;
  
  function throttledScroll() {
    if (scrollTimer) {
      return;
    }
    
    scrollTimer = setTimeout(() => {
      handleScroll();
      scrollTimer = null;
    }, 16); // 約60fps
  }
  
  // イベントリスナーの登録
  window.addEventListener('scroll', throttledScroll, { passive: true });
  window.addEventListener('resize', handleScroll, { passive: true });
  
  // 初期状態の設定
  handleScroll();
}

